import { css } from 'styled-components';

export const breakpoints = {
  xs: 0,
  sm: 520,
  md: 768,
  lg: 992,
  xl: 1200,
};

export const media = {
  lessThan: (breakpoint) => (...args) => css`
    @media (max-width: ${breakpoints[breakpoint] - 1}px) {
      ${css(...args)}
    }
  `,
  between: (min, max) => (...args) => css`
    @media (min-width: ${breakpoints[min]}px) and (max-width: ${breakpoints[max] - 1}px) {
      ${css(...args)}
    }
  `,
  greaterThan: (breakpoint) => (...args) => css`
    @media (min-width: ${breakpoints[breakpoint]}px) {
      ${css(...args)}
    }
  `,
};
